import { HandHeart, GraduationCap, Briefcase, HeartHandshake, Home, ShieldCheck, Users, Sparkles } from "lucide-react";

export const PROGRAMS = [
  {
    icon: Home,
    title: "Supportive Housing",
    desc: "Safe, stable, and affordable housing placements designed to help residents transition toward full independence.",
  },
  {
    icon: GraduationCap,
    title: "Life Skills Training",
    desc: "Hands-on coaching in budgeting, cooking, time management, and everyday decision-making that builds confidence.",
  },
  {
    icon: Briefcase,
    title: "Employment Readiness",
    desc: "Resume building, interview prep, and connections to local employers so residents can secure meaningful work.",
  },
  {
    icon: HeartHandshake,
    title: "Case Management",
    desc: "A dedicated advocate walks alongside each resident with personalized goal plans and consistent check-ins.",
  },
  {
    icon: HandHeart,
    title: "Peer & Faith Support",
    desc: "A believing community that encourages accountability, mentorship, and lasting relationships.",
  },
  {
    icon: ShieldCheck,
    title: "Wellness & Recovery",
    desc: "Connections to counseling, healthcare, and recovery resources that support the whole person.",
  },
];

export const HOUSING = [
  {
    title: "Shared Community Homes",
    desc: "Furnished rooms in welcoming shared homes with common living spaces that foster belonging.",
    img: "https://images.unsplash.com/photo-1661796428215-04fc2830aae6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwzfHxicmlnaHQlMjBtb2Rlcm4lMjBsaXZpbmclMjByb29tJTIwYXBhcnRtZW50JTIwaW50ZXJpb3J8ZW58MHx8fHwxNzgyODY3ODQ2fDA&ixlib=rb-4.1.0&q=85",
    tag: "Most Popular",
  },
  {
    title: "Family-Style Residences",
    desc: "Homey, neighborhood residences offering structure, support, and a true sense of family.",
    img: "https://images.unsplash.com/photo-1560170412-0f7df0eb0fb1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxyZXNpZGVudGlhbCUyMHRvd25ob3VzZSUyMGV4dGVyaW9yJTIwaG9tZXxlbnwwfHx8fDE3ODI4Njc4NDZ8MA&ixlib=rb-4.1.0&q=85",
    tag: "Community",
  },
];

export const STEPS = [
  { n: "01", title: "Submit Your Application", desc: "Fill out our simple intake form below. It takes about 10 minutes and there is no cost to apply." },
  { n: "02", title: "Meet Your Advocate", desc: "We schedule a friendly conversation to understand your story, needs, and goals." },
  { n: "03", title: "Get Matched to Housing", desc: "Together we find the housing option and support plan that fits your journey best." },
  { n: "04", title: "Move In & Thrive", desc: "Settle into your new home with a community and support system cheering you on." },
];

export const VALUES = [
  { icon: Users, label: "Community First", text: "No one walks alone. We build belonging." },
  { icon: Sparkles, label: "Dignity Always", text: "Every person is treated with respect and worth." },
  { icon: ShieldCheck, label: "Safe & Stable", text: "Secure housing is the foundation for growth." },
];
